import React from 'react';

const NotificationCenter = () => {
  const notifications = [
    'New staff member added',
    'System backup completed',
    'Upcoming holiday on Nov 20',
  ];

  return (
    <ul>
      {notifications.map((note, index) => (
        <li key={index}>{note}</li>
      ))}
    </ul>
  );
};

export default NotificationCenter;
